export default __webpack_public_path__ + "images/cryo-high-flag.svg";